import React from 'react'

import classes from './Logo.module.css'

const Logo = () => {

  return (
    <div className={classes.Logo}>
      <h1 className={classes.logo}>
        <img src={"data/images/logo_lot3.png"} alt="Logo" />
      </h1>
    </div>

  );
};

export default Logo;
